/**
 * Converts waypoint offsets to IntersectionObserver rootMargin format
 */
export function calculateRootMargin(topOffset: number | string, bottomOffset: number | string): string {
	const top = formatOffset(topOffset);
	const bottom = formatOffset(bottomOffset);

	// rootMargin format: "top right bottom left"
	// For waypoint behavior, we negate the offsets
	return `-${top} 0px -${bottom} 0px`;
}

function formatOffset(offset: number | string): string {
	if (typeof offset === 'number') {
		return `${offset}px`;
	}
	return offset;
}
